/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpSharedDealerDetailsHeader_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpSharedDealerDetailsStats_viewer$ref: FragmentReference;
export type PdpSharedDealerDetailsStats_viewer = {|
  +$fragmentRefs: PdpSharedDealerDetailsHeader_viewer$ref,
  +$refType: PdpSharedDealerDetailsStats_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpSharedDealerDetailsStats_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDealerDetailsHeader_viewer",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '41ec8a5a65a0aaff652380f455da7491';
module.exports = node;
